module.controller('reissueCtrl', ['$scope', '$state', '$http', '$q', 'cacheService', 'Session', 'Transform', 'baseURI', 'OVERLAY', 'accountService', '$stateParams', function ($scope, $state, $http, $q, cacheService, Session, Transform, baseURI, OVERLAY, accountService, $stateParams){
  var reissueUrl = baseURI + 'card/reissue';
  $scope.card = accountService.getAccount($stateParams.username);

  if ($scope.card.virtual) {
    $scope.headerInfo = 'If your card is compromised, you can get a new card number.';
  } else {
    $scope.headerInfo = 'If your card is lost or stolen, you can have a new card sent to you.';
  }

  $scope.overlay = OVERLAY['member.home.profile/reissue'];
  $scope.formData = {};
  $scope.attempted = false;
  $scope.alert = {};
  $scope.alert.alertMessage = 'Sorry, we were unable to reissue your card at this time.  If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';

  $scope.attemptSubmission = function (formData){
      $scope.alert.errorShown = false;
      $state.go('member.home.profile/reissue.step2');
  };

  $scope.processForm = function(formData){
    reissueCard($stateParams.username);
  };

  var reissueCard = function(username){
    $http({
      method: 'POST',
      url: reissueUrl,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode({Username: username}),
    }).then(function(resp){
      var data = resp.data;

      $scope.loading = false;
      if (data.Success){
        // Clear feed notifications
        cacheService.clear('feeds');

        $scope.alert.successMessage = 'You have reissued your card.';
        $scope.alert.successShown = true;
        $state.go('member.home.profile/reissue.confirmation');
      } else {
        $scope.alert.alertShown = true;
      }
    }).catch(function(error){
        $scope.alert.alertShown = true;
    });
  };
}]);
